<template>
  <div
      class="return-table">
    <el-table
        style="margin:0; border-collapse: collapse;"
        header-cell-class-name="order-table-header"
        :show-header="true"
        :data="returns">
      <el-table-column
          sortable
          prop="return_id"
          label="Return#">
        <template slot-scope="props">
          <el-button
              type="text"
              style="font-size: 14px; font-family: Equip; text-decoration: underline;"
              @click="setCurrentReturn(props.row.return_id)">
            #{{ props.row.return_id }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="created_at"
          label="Return Created On">
        <template slot-scope="props">
          <time-zone-formatter
              :current-time="props.row.created_at"
              output-format="MMM D, YYYY" />
        </template>
      </el-table-column>
      <el-table-column
          prop="source"
          label="Source">
        <template slot-scope="scope">
          <el-tag>{{ displaySource(scope.row) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="state"
          label="Status">
        <template slot-scope="scope">
          <ReturnStatus :order-status="scope.row.state" />
        </template>
      </el-table-column>
      <el-table-column
          prop="return_received"
          label="Return Received">
        <template slot-scope="props">
          <time-zone-formatter
              :current-time="props.row.return_received"
              output-format="MMM D, YYYY" />
        </template>
      </el-table-column>
      <el-table-column
          prop="item_quantity"
          label="Items" />
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
import { createNamespacedHelpers as h } from "vuex";
import ReturnStatus from "./ReturnStatus";
import helper from "@/helpers/TimeZoneFormatterHelper";

const { mapGetters: accountGetters } = h("db/account");

export default {
  name: "ReturnTable",
  components: { ReturnStatus },
  props: {
    searchValue: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      returns: [],
      all_returns: [],
      searchInput: "",
    };
  },
  computed: {
    ...accountGetters(["customerId"]),
  },
  watch: {
    searchValue: function (newVal, oldVal) {
      this.searchInput = newVal;
      this.searchReturn();
    },
  },
  mounted() {
    this.loadReturns();
  },
  methods: {
    setCurrentReturn(id) {
      this.currentReturn = id;
      this.detailsVisible = true;
    },
    loadReturns() {
      this.loading = true;
      this.fetchAccountReturns()
        .catch((error) => console.info("Error loading account returns", error))
        .finally(() => (this.loading = false));
    },
    displaySource(returnOrder) {
      if (
        !returnOrder ||
        !Object.prototype.hasOwnProperty.call(returnOrder, "source")
      ) {
        return "—";
      }
      if (returnOrder.source === "narvar") return "Narvar";
      if (returnOrder.source === null || returnOrder.source === "ND") {
        return "ND";
      }
      return "—";
    },
    fetchAccountReturns() {
      return new Promise((resolve, reject) => {
        let url = `v3/returns/customer_returns?customer_id=${this.customerId}`;
        axios
          .get(url)
          .then((response) => {
            const responseData = response && response.data;
            const returns =
              responseData && Array.isArray(responseData.returns)
                ? responseData.returns
                : [];
            this.returns = returns.map((el) => ({
              ...el,
              items: 1,
            }));
            this.all_returns = this.returns;
            resolve(responseData);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    searchReturn() {
      const dateRegex = /[a-zA-Z]{3} [0-9]{1,2},[ ]{0,1}[0-9]{4}/;
      const searchInput = (this.searchInput || "").trim();
      if (searchInput.length < 1) {
        this.returns = this.all_returns;
      } else if (searchInput.match(/\d{5}/)) {
        this.returns = this.all_returns.filter(function (el) {
          return String(el.return_id) === searchInput;
        });
      } else if (dateRegex.test(searchInput)) {
        this.returns = this.all_returns.filter(function (el) {
          return (
            helper
              .formattedTime(el.created_at, null, "MMM D, YYYY")
              .toLowerCase() === searchInput.toLowerCase()
          );
        });
      } else {
        this.returns = [];
      }
    },
  },
};
</script>

<style>
.el-table.requests td {
  vertical-align: baseline !important;
}
.requests-header {
  /* Heading */
  height: 30px;

  /* heading/small-medium */

  font-family: Equip;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* 🖥 light/content/base */

  color: #424242;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.tab-headers {
  /* Tab Name */

  height: 24px;

  /* body/normal-medium */

  font-family: Equip;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  display: flex;
  align-items: center;

  /* Light/Content/Base */

  color: #6e6e6e;
  border-bottom: 0px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.header-pane {
  /* Heading */

  /* Auto layout */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 24px 24px 0px;
  gap: 16px;
  height: 102px;

  /* 🖥 light/surface/base

  Background color of components, and page background (when white)

  White 900
  */
  background: #ffffff;
  /* Border Bottom

  For cases when a border element cannot be used or when border will need to transition between a shadow and border efficiently in code (ie. Toast Notifications)
  */
  box-shadow: inset 0px -1px 0px #dee5ec;
  border-radius: 8px 8px 0px 0px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.custom-tabs::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 0px;
}

.active-tab {
  color: #000000 !important;
}

.el-table.orders column-header {
  /* Table Columns Header */

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 8px 8px 24px;
  gap: 16px;

  height: 54px;

  /* 🖥 light/tertiary/background

  Tertiary 300
  */
  background: #f6f8fa;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}
.search-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 52px;
  border-bottom: 1px solid #dee5ec;

  input {
    border: 0;
  }
}

.search-box-body {
  font-family: Equip, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #6e6e6e;
}
.order-id-text {
  /* #1108554 */

  /* textlink (inline) /normal-medium

  Use Primary 400 for inline text links
  */
  font-family: Equip;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  padding: 0px 10px;
  /* identical to box height, or 171% */

  display: flex;
  align-items: center;
  text-decoration-line: underline;

  /* 🖥 light/primary/base */

  color: #1998d5;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}
.order-table-header {
  background: #f6f8fa !important;
  font-weight: normal !important;
}
.el-tabs__item.is-active {
  color: #000000 !important;
}
.el-tabs__nav-wrap::after {
  width: 0 !important;
}
.el-table .sort-caret.descending {
  border-top-color: #c0c4cc;
  bottom: 15px;
  margin-bottom: 4px;
}
.el-table .sort-caret.ascending {
  border-bottom-color: #c0c4cc;
  top: 5px;
  display: none;
}
.el-table__body {
  border-collapse: collapse !important;
}
.el-table__row {
  border-bottom: 1px solid rgba(66, 66, 66, 0.1) !important;
}
</style>
